import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { getSeverityColor } from '../../../utils/palette.utils';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { numberFilterOperations } from '../../NRReactGrid/NRReactGrid.utils';
import { CONSTANTS } from '../../../constants/constants';

const getSeverityLabel = input => {
  if (input == null) return '';
  const text = String(input);

  switch (text) {
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_LOW:
      return CONSTANTS.SEVERITIES.LOW;
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_MEDIUM:
      return CONSTANTS.SEVERITIES.MEDIUM;
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_HIGH:
      return CONSTANTS.SEVERITIES.HIGH;
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_CRITICAL:
      return CONSTANTS.SEVERITIES.CRITICAL;
    default:
      return text;
  }
};

function NRSeverityFormatter({ value, column, row }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        padding: theme.spacing(0.75, 1, 0.75, 1.5),
        '&::before': {
          content: '""',
          height: 16,
          position: 'relative',
          left: -12,
          borderRadius: theme.shape.borderRadius,
          borderLeft: `4px solid ${getSeverityColor(value, theme)}`
        }
      }}
    >
      <Typography variant="body2" children={`${row?.cvssScore ?? ''} ${capitalizeFirstLetter(getSeverityLabel(value))}`} />
    </Box>
  );
}
export const NRSeverityProvider = props => (
  <DataTypeProvider formatterComponent={NRSeverityFormatter} availableFilterOperations={numberFilterOperations} {...props} />
);
